module.exports = __webpack_public_path__ + "img/erweima.fed25759.png";